import React, { useEffect } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MainBlockLayout from '../../components/MainBlockLayout';
import registrationReference from '../../images/tuition-fees-reference.svg';

function TuitionFeesContent() {
    const { t } = useTranslation();
    const grantEnquirySubject = encodeURIComponent('School Grant Enquiry 2026-2027');
    const grantEnquiryEmail = `mailto:olesya@stmarysukrschool.co.uk?subject=${grantEnquirySubject}`;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="tuition-fees-page">
            <Card className="tuition-fees-hero mb-4">
                <Card.Body className='tuition-fees-card-body'>
                    <p className="tuition-fees-eyebrow mb-2">St. Mary’s Ukrainian School</p>
                    <h1 className="tuition-fees-title mb-3">{t('tuition_fees.title')}</h1>
                    <p className="tuition-fees-intro mb-0">{t('tuition_fees.intro')}</p>
                </Card.Body>
            </Card>

            <Row className="g-4 align-items-stretch">
                <Col lg={7} className="d-flex">
                    <Card className="tuition-fees-section w-100">
                        <Card.Body>
                            <h2 className="tuition-fees-section-title">{t('tuition_fees.rate_title')}</h2>
                            <p className="tuition-fees-copy">{t('tuition_fees.rate_text')}</p>

                            <div className="tuition-fees-summary">
                                <h3 className="tuition-fees-subtitle">{t('tuition_fees.monthly_title')}</h3>
                                <p className="tuition-fees-copy mb-0">{t('tuition_fees.monthly_text')}</p>
                            </div>

                            <div className="tuition-fees-summary">
                                <h3 className="tuition-fees-subtitle">{t('tuition_fees.annual_title')}</h3>
                                <p className="tuition-fees-copy mb-0">{t('tuition_fees.annual_text')}</p>
                            </div>

                            <p className="tuition-fees-copy">{t('tuition_fees.direct_debit_note')}</p>

                            <div className="tuition-fees-summary">
                                <h3 className="tuition-fees-subtitle">{t('tuition_fees.discount_title')}</h3>
                                <p className="tuition-fees-copy mb-0">{t('tuition_fees.discount_text')}</p>
                            </div>

                            <div className="tuition-fees-summary mb-0">
                                <h3 className="tuition-fees-subtitle">{t('tuition_fees.grants_title')}</h3>
                                <p className="tuition-fees-copy">{t('tuition_fees.grants_intro')}</p>
                                <ul className="tuition-fees-bullets">
                                    <li>{t('tuition_fees.grants_item1')}</li>
                                    <li>{t('tuition_fees.grants_item2')}</li>
                                    <li>{t('tuition_fees.grants_item3')}</li>
                                </ul>
                                <p className="tuition-fees-copy mb-2">
                                    {t('tuition_fees.grants_contact')}{' '}
                                    <a href={grantEnquiryEmail}>olesya@stmarysukrschool.co.uk</a>.
                                </p>
                                <p className="tuition-fees-copy mb-0">{t('tuition_fees.grants_click_note')}</p>
                            </div>

                            <p className="tuition-fees-signoff mt-4 mb-0">{t('tuition_fees.signoff')}</p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={5} className="d-flex">
                    <Card className="tuition-fees-section w-100">
                        <Card.Body className="d-flex flex-column">
                            <h2 className="tuition-fees-section-title text-center">{t('tuition_fees.reference_title')}</h2>
                            <p className="tuition-fees-copy text-center">{t('tuition_fees.reference_instruction')}</p>

                            <div className="tuition-fees-payment-art mt-2">
                                <img
                                    src={registrationReference}
                                    alt={t('tuition_fees.reference_alt')}
                                    className="tuition-fees-payment-image"
                                />
                            </div>

                            <p className="tuition-fees-caption text-center mt-3 mb-0">{t('tuition_fees.reference_caption')}</p>

                            <div className="text-center mt-4">
                                <Button
                                    as="a"
                                    href="https://buy.stripe.com/cNidRa3N84Ecft15nL24004"
                                    target="_blank"
                                    rel="noreferrer"
                                    size="lg"
                                    className="tuition-fees-payment-button"
                                >
                                    {t('tuition_fees.button_text')}
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default MainBlockLayout(TuitionFeesContent);